<child-header title="Confirm Pending Total" (closeEvent)="onNoClick()"></child-header>
<div mat-dialog-content style="font-size: 12px; width: 100%; padding: 13px 24px 0 24px; margin: 0;">
  <p>
    {{ data.hasProrated ? 'Prorated' : '' }} Total is &nbsp;<span
      class="color-red bold">{{data.totalPriceChange | currency:'AUD':'symbol-narrow':'.2-2'}}</span>&nbsp;&nbsp;
  </p>
  <p>
    Once you have confirmed the order total noted above this request will be sent to Adobe for verification and
    actioning. This portal will be automatically updated once Adobe have confirmed your requested changes are
    live in their systems. Until this confirmation is received, your Adobe Market Place subscriptions will remain in
    their
    current state.
    If you have any questions regarding this process or the changes you are applying, please contact your Dicker
    Data
    representative.
  </p>

  <mat-form-field>
    <input matInput type="text" maxlength="30" class="poReference" [(ngModel)]="poReference" placeholder="PO REFERENCE" (input)="commonService.subscription_customer_ref_validation($event)" />
  </mat-form-field>
  <!-- <mat-checkbox [(ngModel)]="confirmChecked">
    Partner attestation *
  </mat-checkbox>
  <div class="confirm-label" (click)="checkConfirmBox()">
    <label>
      I confirm that my organization is acting as an Indirect Partner when choosing a Reseller and as a Direct Partner in the absence of selecting a reseller.<br/>
      I confirm that I am not reselling products purchased within this order to other partners that are affiliated with my parent organization
    </label>
  </div>
   -->
</div>
<div mat-dialog-actions style="display: block; margin: 0 auto; min-height: 52px; max-width: 302px;">
  <button mat-button class="button button-red button-large continue" [disabled]="!poReference" (click)="continueSaveSubscription()">Continue</button>
</div>

